import { type INotiState } from '@interface/INoti';
import { createSlice } from '@reduxjs/toolkit';

const initialState: INotiState = {
    modifyItemData: {
        id: '',
        itemId: 0,
        serverId: 0,
        enchantLevel: 0,
        enchantLevelMax: 0,
        serverName: '',
        price: 0,
        period: 0,
        image: '',
        itemName: '',
        remain: 0,
        grade: 0,
        blessed: 0,
        prices: {
            now: 0,
            min: 0,
            last: 0,
        },
    },
};

export const notiSlice = createSlice({
    name: 'notiSlice',
    initialState,
    reducers: {
        setModifyItemData: (state, action) => {
            state.modifyItemData = action.payload;
        },
    },
});

export const { setModifyItemData } = notiSlice.actions;

export default notiSlice.reducer;
